import React from 'react'
import { useTranslation } from 'react-i18next'

import { historyParticipation } from 'src/axious/history-participation'
import { Header } from 'src/components'
import { Tabs } from 'src/components/ui'
import { useChangeBackground } from 'src/hooks/useChangeBackground'
import { handleAxiosError } from 'src/utils/errorHandling'

import styles from './BanksPaticipation.module.scss'
import { HistoryMissing, MainInfo } from './components'
import { HistoryParticipationType } from './components/MainInfo/BanksParticipation.types'

const BanksParticipation = () => {
  const [historyParticipations, setHistoryParticipations] = React.useState<HistoryParticipationType[]>([])
  useChangeBackground(styles['white-background'])

  const { t } = useTranslation()
  const historyIsMissing = historyParticipations.length === 0

  React.useEffect(() => {
    const getHistoryParticipation = async () => {
      try {
        const res = await historyParticipation(1)
        setHistoryParticipations(res)
      } catch (err) {
        const errorMessage = handleAxiosError(err)
        console.log(errorMessage)
      }
    }

    getHistoryParticipation()
  }, [])

  return (
    <>
      <Header variant='settings' path='..' setting={t('history_participations.label')} color='black' />

      <main className={styles.main}>
        {!historyIsMissing && (
          <>
            <div className={styles.main_container}>
              <Tabs
                titles={[
                  { name: t('history_participations.titles.broken'), mode: 'broken' },
                  { name: t('history_participations.titles.unbroken'), mode: 'unbroken' },
                ]}
              />
            </div>

            <MainInfo historyParticipations={historyParticipations} />
          </>
        )}

        {historyIsMissing && <HistoryMissing />}
      </main>
    </>
  )
}

export default BanksParticipation
